import React from "react";
import { CbTemplateViewProps } from "../../../types/cb-template-view/cb-template-view.props";
import { TemplateView } from "../../../../../types/templates/template-view.interface";
import {
  CbTemplateBrand,
  CbTemplateGeneral,
  CbTemplateNewProductLaunch,
  CbTemplateSimpleSingleAsset,
} from "../components";
import { CAMPAIGN_TEMPLATE } from "../../../../../types/templates/campaign-brief/campaign-brief-template.enum";
import { CbTemplateView } from "../../../types/cb-template-view/cb-template-view.type";

export function getCbTemplateViewFromType(type: CAMPAIGN_TEMPLATE): React.FC<CbTemplateViewProps> {
  const view = getCbTemplateViews().find((template) => template.name === type)?.view;
  if (view) {
    return view;
  }
  throw new Error(`No Campaign Brief Template View configured for ${type}`);
}

const getCbTemplateViews = (): TemplateView<CbTemplateView>[] => [
  {
    name: CAMPAIGN_TEMPLATE.BRAND,
    view: CbTemplateBrand,
  },
  {
    name: CAMPAIGN_TEMPLATE.SIMPLE,
    view: CbTemplateSimpleSingleAsset,
  },
  {
    name: CAMPAIGN_TEMPLATE.NEW_PRODUCT,
    view: CbTemplateNewProductLaunch,
  },
  {
    name: CAMPAIGN_TEMPLATE.GENERAL,
    view: CbTemplateGeneral,
  },
];
